import { put, takeLatest, call } from "redux-saga/effects";
import { CITIES_PAGE_LOAD, citiesLoaded } from "../../actions/cities";
import listCities from "../../../../../backend/oncall/partners/cities/list";
import { showErrorPage } from "../../../../../actions/ui/location";

const citiesPageLoadSaga = function*(action) {
  try {
    const result = yield call(listCities);
    yield put(citiesLoaded(result.cities));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(CITIES_PAGE_LOAD, citiesPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/cities/list-page-load.js